<template>
  <div>
    <textarea
      v-model="model"
      class="textarea"
      :placeholder="placeholder"
      :maxlength="VALIDATION.MAX_FREE_TEXT_LENGTH"
      :rows="rows"
      :aria-describedby="ariaDescribedby"
    />
    <div class="counter">残り{{ remainingChars }}文字</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VALIDATION } from '../types';

withDefaults(
  defineProps<{
    placeholder?: string;
    rows?: number;
    ariaDescribedby?: string;
  }>(),
  {
    placeholder: '',
    rows: 4,
    ariaDescribedby: undefined,
  }
);

const model = defineModel<string>({ default: '' });

const remainingChars = computed(() => {
  const currentLength = model.value.length;
  return VALIDATION.MAX_FREE_TEXT_LENGTH - currentLength;
});
</script>

<style lang="scss" scoped>
// 基本スタイルは各親コンポーネントで定義
// 例: .chat-questionnaire-free-text .textarea { ... }
// 例: .step-free-text-input .textarea { ... }
</style>
